import {
  Box,
  DialogContentText,
  DialogActions,
  Button,
  Typography,
  useTheme,
} from '@mui/material';
import AutorenewIcon from '@mui/icons-material/Autorenew';

import CustomDialogModal from './Custom';

const ConfirmDialogModal = ({
  isOpen,
  text,
  title,
  icon = 'refresh',
  onConfirm,
  onCancel,
  showVolver = false,
  cancelText = 'Cancelar',
  confirmText = 'Confirmar',
  maxWidth,
}) => {
  const theme = useTheme();

  return (
    <CustomDialogModal
      open={isOpen}
      onClose={onCancel}
      sxDialog={maxWidth ? { '& .MuiDialog-paper': { maxWidth } } : undefined}
    >
      {title ? (
        <Box sx={{ display: 'flex', gap: 1.75, alignItems: 'flex-start' }}>
          {icon === 'refresh' && (
            <Box
              sx={{
                flex: 'none',
                width: 40,
                height: 40,
                borderRadius: '50%',
                bgcolor: '#F3E8FF',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <AutorenewIcon sx={{ color: theme.tertiary, fontSize: 22 }} />
            </Box>
          )}
          <Box>
            <Typography
              sx={{ fontSize: 17, fontWeight: 700, color: '#1A1A1A', mb: 0.75 }}
            >
              {title}
            </Typography>
            {text && (
              <Typography
                sx={{ fontSize: 14, color: '#4B5563', lineHeight: 1.5 }}
              >
                {text}
              </Typography>
            )}
          </Box>
        </Box>
      ) : (
        text && <DialogContentText>{text}</DialogContentText>
      )}
      <DialogActions
        sx={{ justifyContent: 'center', gap: 2, p: '16px 16px 0px 16px' }}
      >
        {showVolver ? (
          ' '
        ) : (
          <Button
            variant="outlined"
            onClick={onCancel}
            sx={{ color: '#000', borderColor: theme.tertiary }}
          >
            {cancelText}
          </Button>
        )}
        <Button
          variant="contained"
          onClick={onConfirm}
          sx={{ backgroundColor: theme.tertiary, color: '#fff' }}
        >
          {showVolver ? 'Volver' : confirmText}
        </Button>
      </DialogActions>
    </CustomDialogModal>
  );
};

export default ConfirmDialogModal;
